import styles from "styles/BasketSidebar.module.scss";
import emptyCardImg from "images/empty_cart.svg";
import GetIcon from "components/GetIcon";
import Title from "components/Title";
import clsx from "clsx";
import BasketItem from "components/BasketItem";
import { BasketContext } from "context/BasketContext";
import { useContext, useRef } from "react";
import OrderButton from "./OrderButton";

const BasketSidebar = () => {
  const { basketIsOpen, setBasketIsOpen, basketItems, basketTotal: _basketTotal } = useContext(BasketContext);
  const container = useRef();

  // Ensure _basketTotal is a number before calling toFixed()
  const formattedTotal = parseFloat(_basketTotal).toFixed(2);

  return (
      <div
          className={clsx(styles.sidebarContainer, basketIsOpen ? styles.show : styles.hide)}
          ref={container}
          onClick={(event) => event.target === container.current && setBasketIsOpen(false)}
      >
        <div className={styles.sidebar}>
          <div className={styles.header}>
            <div className={styles.title}>
              <Title txt="Tu Carrito" size={20} transform="uppercase" />
              {<small>Tienes {basketItems.length} articulos en el carrito</small>}
            </div>
            <button className={styles.close} onClick={() => setBasketIsOpen(false)}>
              <GetIcon icon="BsX" size={30} />
            </button>
          </div>
          {basketItems.length > 0 ? (
              <>
                <div className={styles.items}>
                  {basketItems?.map((item, key) => (
                      <BasketItem data={item} key={key} />
                  ))}
                </div>
                <div className={styles.basketTotal}>
                  <div className={styles.total}>
                    <Title txt="Monto" size={23} transform="uppercase" />
                    <GetIcon icon="BsFillCartCheckFill" size={25} />
                  </div>
                  <div className={styles.totalPrice}>
                    <small>total</small>
                    <div className={styles.price}>
                      <small>₡ </small>
                      <span>{formattedTotal}</span>
                    </div>
                  </div>
                  <OrderButton buttonText="Confirmar Carrito" phoneNumber="50670764648" />
                </div>
              </>
          ) : (
              <div className={styles.emptyBasket}>
                <img src={emptyCardImg} alt="Empty Cart" />
                <Title txt="Tu carrito esta vacio :(" size={23} transform="uppercase" />
              </div>
          )}
        </div>
      </div>
  );
};

export default BasketSidebar;